import React, { useEffect, useRef, useState } from "react";
import { TSiteTemplate } from "../components/TSiteTemplate";
import { HomeHeroSection } from "../components/HomeHeroSection";
import { FeaturedProjectsSection } from "../components/FeaturedProjectsSection";
import { ProjectDetailsDialog } from "../components/ProjectDetailsDialog";
import { ServiceCard } from "../components/ServiceCard";
import { SkillCard } from "../components/SkillCard";
import { ContactCard } from "../components/ContactCard";
import { SectionHeader } from "../components/SectionHeader";
import SmokeCursor from "../components/SmokeHoverSection";
import { MockData } from "../data/mock";

export const HomeScreen = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth);

  useEffect(() => {
  const handleResize = () => {
    setViewportWidth(window.innerWidth);
  };

  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const isMobile = viewportWidth < 820;
  const isTablet = viewportWidth >= 820 && viewportWidth < 1280;
  const isDesktop = viewportWidth >= 1280;

  const infoData = MockData.infos[0] || {
    title: "Mobile App Developer",
    bio: "I build modern, scalable, and beautiful mobile applications using Flutter, clean architecture, APIs, and smooth user experiences.",
  };

  const sectionRefs = useRef([]);
  const isProgrammaticScroll = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isProgrammaticScroll.current) return;
      const scrollPosition = window.scrollY + 140;
      let targetIndex = 0;
      sectionRefs.current.forEach((ref, index) => {
        if (ref) {
          const offsetTop = ref.offsetTop;
          if (scrollPosition >= offsetTop) targetIndex = index;
        }
      });
      if (currentIndex !== targetIndex) setCurrentIndex(targetIndex);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [currentIndex]);

  const goToSection = (index) => {
    const targetRef = sectionRefs.current[index];
    if (!targetRef) return;
    isProgrammaticScroll.current = true;
    setCurrentIndex(index);
    window.scrollTo({ top: targetRef.offsetTop - 100, behavior: "smooth" });
    setTimeout(() => {
      isProgrammaticScroll.current = false;
    }, 720);
  };

  const sectionStyle = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1440px",
    padding: !isMobile ? "0 40px" : "0 15px",
    margin: "0 auto",
    boxSizing: "border-box",
  };

  return (
    <TSiteTemplate currentIndex={currentIndex} onSectionTap={goToSection}>
      <main style={{ width: "100%" }}>
        <div
          ref={(el) => (sectionRefs.current[0] = el)}
          style={{ position: "relative", overflow: "hidden", width: "100%" }}
        >
          <SmokeCursor />
          <div style={{ position: "relative", zIndex: 2, width: "100%" }}>
            <HomeHeroSection
              info={infoData}
              projectsCount={MockData.projects.length}
              servicesCount={MockData.services.length}
              skillsCount={MockData.skills.length}
            />
          </div>
        </div>

        {/* <div ref={(el) => (sectionRefs.current[1] = el)} style={sectionStyle}>
          <div style={containerStyle}>
            <h1 style={{ color: 'white', margin: 0 }}>Section 1</h1>
          </div>
        </div> */}

        <div ref={(el) => (sectionRefs.current[2] = el)} style={sectionStyle}>
          <div style={containerStyle}>
            <FeaturedProjectsSection
              projects={MockData.projects.map((p) => ({
                ...p,
                onClick: () => setSelectedProject(p),
              }))}
            />
          </div>
        </div>

        <div ref={(el) => (sectionRefs.current[3] = el)} style={sectionStyle}>
          <div style={containerStyle}>
            <SectionHeader
              eyebrow="What I Do"
              title="Services"
              subtitle="End-to-end solutions for building, integrating, and improving mobile applications."
            />
            <div
              style={{
                marginTop: "22px",
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(min(100%, 360px), 1fr))",
                gap: "32px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {MockData.services.map((service, index) => (
                <ServiceCard key={service.id || index} service={service} />
              ))}
            </div>
          </div>
        </div>

        <div ref={(el) => (sectionRefs.current[4] = el)} style={sectionStyle}>
          <div style={containerStyle}>
            <SectionHeader
              eyebrow="Tech Stack"
              title="Skills"
              subtitle="Technologies and practices I use to build scalable, maintainable, and elegant products."
            />
            <div
              style={{
                marginTop: "22px",
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "12px 10px",
                boxSizing: "border-box",
              }}
            >
              {MockData.skills.map((skill, index) => (
                <SkillCard key={skill.id || index} skill={skill} />
              ))}
            </div>
          </div>
        </div>

        <div ref={(el) => (sectionRefs.current[5] = el)} style={sectionStyle}>
          <div style={containerStyle}>
            <SectionHeader
              eyebrow="Let's Connect"
              title="Contact"
              subtitle="Reach me through any platform and let's build something clean, fast, and beautiful."
            />
            <div
              style={{
                marginTop: "22px",
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(min(100%, 420px), 1fr))",
                gap: "32px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {MockData.contacts.map((contact, index) => (
                <ContactCard key={contact.id || index} contact={contact} />
              ))}
            </div>
          </div>
        </div>
      </main>

      {selectedProject && (
        <ProjectDetailsDialog
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </TSiteTemplate>
  );
};
